import { render, staticRenderFns } from "./ManualExtService.vue?vue&type=template&id=1a1138b6&scoped=true"
import script from "./ManualExtService.vue?vue&type=script&lang=js"
export * from "./ManualExtService.vue?vue&type=script&lang=js"
import style0 from "./ManualExtService.vue?vue&type=style&index=0&id=1a1138b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1138b6",
  null
  
)

export default component.exports